import PropTypes from 'prop-types';
import { richtextType } from './richtext';

export const questionAndAnswerShape = {
  question: richtextType,
  answer: richtextType,
};

export const questionAndAnswerType = PropTypes.shape(questionAndAnswerShape);
